import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  gutter: {
    height: "4rem"
  }
});

export default function Gutter() {
  const classes = useStyles();
  return <div className={classes.gutter} />;
}
